export const LIST_OBSERVATION_FEEDBACKS = 'LIST_OBSERVATION_FEEDBACKS'
export const LIST_OBSERVATION_FEEDBACKS_SUCCESS = 'LIST_OBSERVATION_FEEDBACKS_SUCCESS'
export const LIST_OBSERVATION_FEEDBACKS_FAILED = 'LIST_OBSERVATION_FEEDBACKS_FAILED'

export const CLEAR_OBSERVATION_FEEDBACK_LISTS = 'CLEAR_OBSERVATION_FEEDBACK_LISTS'
